import VueRouter from 'vue-router'
import Vue from 'vue'
import Security from './core/Security.js'

// PAGES
import Home from '../components/main/Home.vue'
import Login from '../components/main/Login.vue'
import Config from '../components/main/Config.vue'
import Profil from '../components/main/Profil.vue'
import initLoading from '../components/main/InitLoading.vue'
import OfflineActions from '../components/main/OfflineActions.vue'
import Synchro from '../components/main/Synchro.vue'

import ListeBouteilles from '../components/bouteille/ListeBouteilles.vue'
import Bouteille from '../components/bouteille/Bouteille.vue'
import BouteilleRegul from '../components/bouteille/BouteilleRegul.vue'
import NewBouteille from '../components/bouteille/NewBouteille.vue'
import RestitutionBouteilles from '../components/bouteille/RestitutionBouteilles.vue'
import ScanOtag from '../components/bouteille/ScanOtag.vue'

import ListeDetenteurs from '../components/detenteur/ListeDetenteurs.vue'
import Detenteur from '../components/detenteur/Detenteur.vue'
import NewDetenteur from '../components/detenteur/NewDetenteur.vue'

import ListeInstallations from '../components/installation/ListeInstallations.vue'
import Installation from '../components/installation/Installation.vue'
import NewInstallation from '../components/installation/NewInstallation.vue'

import ListeOutils from '../components/outil/ListeOutils.vue'
import Outil from '../components/outil/Outil.vue'
import NewOutil from '../components/outil/NewOutil.vue'

import ListeFibsdd from '../components/fiches/bsdd/ListeFibsdd.vue'
import Fibsdd from '../components/fiches/bsdd/Fibsdd.vue'
import NewFibsdd from '../components/fiches/bsdd/NewFibsdd.vue'

import CtrlMulti from '../components/fiches/multictrl/MultiCtrlEtanch.vue'

import ContratAssemblage from '../components/fiches/assemblage/ContratAssemblage.vue'

import ScanInstall from "../components/installation/ScanInstall.vue";

import Gazo from "../components/main/Gazo.vue";
import Spie from "../components/fiches/bsdd/Spie.vue";
import InformationInstallation from "../components/installation/InformationInstallation.vue";
import Sso from "@/components/main/Sso.vue";

let routes = [


    // ROUTES GLOBALES

    {
        path: '/sso/callback',
        name: 'sso-callback',
        meta: {ssoConnexion: true},
        component: Sso
    },
    {
        path: '/home',
        name: 'home',
        meta: {logNeeded: true},
        component: Home
    },
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/login',
        name: 'login',
        meta: {loginPage: true},
        component: Login
    },
    {
        path: '/configuration',
        name: 'configuration',
        meta: {logNeeded: true},
        component: Config
    },
    {
        path: '/init',
        name: 'init',
        meta: {logNeeded: true},
        component: initLoading
    },
    {
        path: '/profil',
        name: 'profil',
        meta: {logNeeded: true},
        component: Profil
    },
    {
        path: '/liste-offline',
        name: 'liste-offline',
        meta: {logNeeded: true},
        component: OfflineActions
    },
    {
        path: '/synchro',
        name: 'synchro',
        meta: {logNeeded: true},
        component: Synchro
    },


    // ROUTES BOUTEILLES


    {
        path: '/liste-bouteilles',
        name: 'liste-bouteilles',
        meta: {logNeeded: true},
        component: ListeBouteilles
    },
    {
        path: '/new-bouteille',
        name: 'new-bouteille',
        meta: {logNeeded: true},
        component: NewBouteille
    },
    {
        path: '/bouteille/:id',
        name: 'bouteille',
        meta: {logNeeded: true},
        component: Bouteille
    },
    {
        path: '/bouteille/:id/regul',
        name: 'bouteille-regul',
        meta: {logNeeded: true},
        component: BouteilleRegul
    },
    {
        path: '/restitution-bouteilles',
        name: 'restitution-bouteilles',
        meta: {logNeeded: true},
        component: RestitutionBouteilles
    },
    {
        path: '/itag/:str/:idDet',
        name: 'scan-install',
        meta: { logNeeded: true },
        component: ScanInstall
    },
    {
        path: '/otag/:str',
        name: 'scan-otag',
        meta: {logNeeded: true},
        component: ScanOtag
    },


    // ROUTES DETENTEURS & INSTALLATIONS


    {
        path: '/liste-detenteurs',
        name: 'liste-detenteurs',
        meta: {logNeeded: true},
        component: ListeDetenteurs
    },
    {
        path: '/new-detenteur',
        name: 'new-detenteur',
        meta: {logNeeded: true},
        component: NewDetenteur
    },
    {
        path: '/detenteur/:id',
        name: 'detenteur',
        meta: {logNeeded: true},
        component: Detenteur
    },
    {
        path: '/detenteur/:id/installations/',
        name: 'liste-installations',
        meta: {logNeeded: true},
        component: ListeInstallations
    },
    {
        path: '/detenteur/:id/installations/new',
        name: 'new-installation',
        meta: {logNeeded: true},
        component: NewInstallation
    },
    {
        path: '/detenteur/:id/installations/:idInst',
        name: 'installation',
        meta: {logNeeded: true},
        component: Installation
    },
    {
        path: '/detenteur/:id/installations/:idInst/information',
        name: 'information-installation',
        meta: { logNeeded: true },
        component: InformationInstallation
    },


    // ROUTES FICHES


    {
        path: '/liste-fibsdd',
        name: 'liste-fibsdd',
        meta: {logNeeded: true},
        component: ListeFibsdd
    },
    {
        path: '/new-fibsdd',
        name: 'new-fibsdd',
        meta: {logNeeded: true},
        component: NewFibsdd
    },
    {
        path: '/fibsdd/:id',
        name: 'fibsdd',
        meta: {logNeeded: true},
        component: Fibsdd
    },
    {
        path: '/contrat-assemblage',
        name: 'contrat-assemblage',
        meta: {logNeeded: true},
        component: ContratAssemblage
    },
    {
        path: '/ctrl-multi',
        name: 'ctrl-multi',
        meta: {logNeeded: true},
        component: CtrlMulti
    },


    // ROUTES OUTILS


    {
        path: '/liste-outils',
        name: 'liste-outils',
        meta: {logNeeded: true},
        component: ListeOutils
    },
    {
        path: '/new-outil',
        name: 'new-outil',
        meta: {logNeeded: true},
        component: NewOutil
    },
    {
        path: '/outil/:id',
        name: 'outil',
        meta: {logNeeded: true},
        component: Outil
    },


    //CONNECTOR GAZOLEEN

    {
        path: '/connector/gazoleen',
        name: 'connector-gazoleen',
        meta: {logNeeded: true},
        component: Gazo
    },


    //SPECIAL SPIE
    {
        path: '/spie/:id_det/:id_inst/:num_ot',
        name: 'spie',
        meta: {logNeeded: true},
        component: Spie
    },

    // Aucune route ne matchait jusqu'ici : <router-view> ne rendait alors
    // rien, écran blanc sans header ni menu, et sans retour possible
    // autrement qu'en éditant le hash. Le cas devient atteignable dès qu'une
    // route disparaît — un onglet restauré sur l'ancien hash, ou un
    // pendingRedirectAfterLogin posé avant la mise à jour.
    {
        path: '*',
        redirect: '/home'
    }
];

const router = new VueRouter({
    mode: 'hash',
    routes
});

router.beforeEach((to, from, next) => {
    var security = new Security;

    if (to.matched.some(record => record.meta.ssoConnexion)) {
        next()
    } else if (to.matched.some(record => record.meta.logNeeded)) {
        security.isLogged(function (res) {
            if (res === true) {
                next();
            } else {
                Security.tryRefreshProfil(function(recovered, profil, refus) {
                    if (recovered) {
                        Vue.prototype.$user = profil;
                        localforage.getItem('offlineActions').then(function(raw) {
                            const actions = JSON.parse(raw);
                            if (Array.isArray(actions) && actions.length > 0) {
                                // Handler de rejet : sweetalert2 6.x rejette sur esc
                                // et clic exterieur, sans quoi next() n'est jamais
                                // appele et la navigation reste pendante.
                                const versHome = function() { next({ name: 'home' }); };
                                swal('Données non synchronisées', "Veuillez synchroniser vos données hors ligne au plus vite.", 'warning')
                                    .then(versHome, versHome);
                            } else {
                                if (to.name !== 'init') {
                                    sessionStorage.setItem('pendingRedirectAfterLogin', to.fullPath);
                                }
                                next({ name: 'init' });
                            }
                        }).catch(function() {
                            sessionStorage.setItem('pendingRedirectAfterLogin', to.fullPath);
                            next({ name: 'init' });
                        });
                    } else if (refus) {
                        // MD-565 : le serveur refuse l'accès (évaluation terminée,
                        // opérateur désactivé). On purge la session et on annonce le
                        // motif.
                        //
                        // On ne tente PAS de pousser la file hors-ligne au passage :
                        // Api.init() est gardé par isLogged() (core/Api.js), faux par
                        // construction ici, donc aucune requête de synchronisation ne
                        // peut aboutir depuis cette branche. La file reste stockée sur
                        // l'appareil — logoutRefus() ne la touche pas — et
                        // InitLoading.vue la resurface au prochain login réussi une
                        // fois le compte réactivé.
                        const deconnecter = function(nbEnAttente) {
                            Security.logoutRefus(function() {
                                let message = Security.libelleRefus(refus);
                                if (nbEnAttente > 0) {
                                    message += '<br><br>' + nbEnAttente + " élément(s) non synchronisé(s) sont conservés sur cet appareil et pourront être envoyés dès la réactivation du compte.";
                                }

                                // {name: 'login'} et non 'login' : vue-router 2
                                // resout une chaine relative contre from.path, ce
                                // qui donne /detenteur/5/installations/login depuis
                                // une route imbriquee — aucune route ne matche et il
                                // n'existe pas de catch-all.
                                const versLogin = function() { next({ name: 'login' }); };
                                swal({
                                    title: 'Accès refusé',
                                    html: message,
                                    type: 'error'
                                }).then(versLogin, versLogin);
                            });
                        };

                        localforage.getItem('offlineActions').then(function(raw) {
                            const actions = JSON.parse(raw);
                            deconnecter(Array.isArray(actions) ? actions.length : 0);
                        }).catch(function() {
                            deconnecter(0);
                        });
                    } else {
                        sessionStorage.setItem('pendingRedirectAfterLogin', to.fullPath);
                        next({ name: 'login' });
                    }
                });
            }
        })
    } else if (to.matched.some(record => record.meta.loginPage)) {
        security.isLogged(function (res) {
            if (res === true) {
                next('init')
            } else {
                next()
            }
        })

    } else {
        next()
    }
});


if (window.location.pathname === '/sso/call') {
    let params = new URL(window.location.href).searchParams;
    let code = params.get('code');
    window.location.href = '/#/sso/callback?code=' + code;
}

export default router



// WEBPACK FOOTER //
// ./src/js/routes.js